import OpenSeadragon from 'openseadragon'
import navigator from '../navigator'
import { AssetsService } from '@coosmo/shared-utils'
import linkViewers from '../linkViewers'

const closeIcon = AssetsService.getSvgIcon('close.svg')
const infoIcon = AssetsService.getSvgIcon('info.svg')

let viewersVisibility = {
  viewer0: true,
  viewer1: false,
  viewer2: true
}

function sendToParent(event) {
  try {
    parent.dispatchEvent(event)
  } catch (corsNotAllowed) {}
}

function createViewerDom(viewerIndex, percentage, title, author, description) {
  const isFirstViewer = viewerIndex === 0

  const infoBox = `
<div id="infoBox" class="away">
    <div id="close" class="infoButton">
        <img src="${closeIcon}">
    </div>
    <div id="author">${author}</div>
    <div id="title">${title}</div>
    <div id="description">${description}</div>
</div>
<div id="infoOpen" class="infoButton">
    <img src="${infoIcon}">
</div>
`

  let navigatorDOM = isFirstViewer ? navigator.createDom(true) : ''
  const viewer = `
<div class="viewer" id="viewer${viewerIndex}" style="width:${percentage}%; left:${percentage * viewerIndex}%">
</div>`
  const view = `${viewer}${isFirstViewer ? `${navigatorDOM}${infoBox}` : ''}`
  const widgetContainer = document.getElementById('widgetContainer')
  widgetContainer.insertAdjacentHTML('beforeend', view)
}

function getAllViewersIds(viewersVisibility) {
  return Object.keys(viewersVisibility)
}

function getVisibleViewersIds(viewersVisibility) {
  return getAllViewersIds(viewersVisibility).filter(key => viewersVisibility[key])
}

function getNotVisibleViewersIds(viewersVisibility) {
  return getAllViewersIds(viewersVisibility).filter(key => !viewersVisibility[key])
}

function ensureFirstViewerHasRightSizeToAvoidZoomValueProblems(percentage) {
  document.getElementById('viewer0').style['width'] = `${percentage}%`
}

function showViewers(viewersVisibility) {
  const visibleViewersIds = getVisibleViewersIds(viewersVisibility)
  const percentage = 100 / visibleViewersIds.length

  visibleViewersIds.forEach((viewerId, index) => {
    const viewer = document.getElementById(viewerId)
    viewer.style.zIndex = '-10'
    viewer.style['width'] = `${percentage}%`
    viewer.style['left'] = `${percentage * index}%`
    viewer.style.transform = 'scale(1)'
  })

  const notVisibleViewersIds = getNotVisibleViewersIds(viewersVisibility)
  notVisibleViewersIds.forEach((viewerId, index) => {
    const viewer = document.getElementById(viewerId)
    viewer.style.zIndex = '-20'
    viewer.style['width'] = `${percentage}%`
    viewer.style.transform = 'scale(0)'
  })

  ensureFirstViewerHasRightSizeToAvoidZoomValueProblems(percentage)
}

function setupButton(buttonId, index) {
  const button = document.getElementById(buttonId)
  button.addEventListener('mousedown', () => {
    linkViewers.disable()
    if (button.classList.contains('selected') && getVisibleViewersIds(viewersVisibility).length <= 1) {
      return
    }

    button.classList.toggle('selected')
    const currentViewerId = `viewer${index}`
    viewersVisibility[currentViewerId] = button.classList.contains('selected')

    getAllViewersIds(viewersVisibility).forEach(viewerId => {
      document.getElementById(viewerId).style.zIndex = '-20'
    })

    showViewers(viewersVisibility)
  })

  button.addEventListener('mouseup', () => {
    setTimeout(() => linkViewers.enable(), 400)
  })
}

function setupInfoBoxEvents() {
  const infoBox = document.getElementById('infoBox')

  const infoOpenButton = document.getElementById('infoOpen')
  infoOpenButton.addEventListener('click', () => {
    infoBox.classList.remove('away')
    infoOpenButton.classList.add('away')
  })

  const closeButton = document.getElementById('close')
  closeButton.addEventListener('click', () => {
    infoOpenButton.classList.remove('away')
    infoBox.classList.add('away')
  })
}

function createViewers(imagesMetaData, onPremisesData) {
  const visibleViewersCount = getVisibleViewersIds(viewersVisibility).length
  const maxZoomPixelRatio = imagesMetaData[0].maxZoomPixelRatio
  const percentage = 100 / visibleViewersCount

  const viewersList = []

  imagesMetaData.forEach((imageData, index) => {
    createViewerDom(index, percentage, onPremisesData.title, onPremisesData.author, onPremisesData.description)

    const viewer = OpenSeadragon({
      id: `viewer${index}`,
      prefixUrl: 'openseadragon/',
      tileSources: imageData.tileSources,
      sequenceMode: true,
      showReferenceStrip: imageData.tileSources.length > 1,
      referenceStripScroll: 'vertical',
      homeButton: 'home',
      fullPageButton: null,
      animationTime: 1.75,
      maxZoomPixelRatio: maxZoomPixelRatio,
      homeFillsViewer: false,
      gestureSettingsMouse: {
        flickEnabled: false,
        clickToZoom: false,
        dblClickToZoom: true
      },
      showNavigator: index === 0,
      navigatorAutoFade: false,
      navigatorPosition: 'BOTTOM_RIGHT',
      loadTilesWithAjax: true,
      ppi: imageData.ppi,
      navigatorHeight: '279px',
      navigatorWidth: '287px',
      navigatorId: index === 0 ? `navigator` : null,
      zoomInButton: 'zoom-in',
      zoomOutButton: 'zoom-out',
      preserveImageSizeOnResize: true
    })

    if (index === 0) {
      navigator.setup(viewer)
    }

    viewersList.push(viewer)
  })

  linkViewers.init(viewersList)

  const buttonsIds = ['vis-viewer', 'uv-viewer', 'rest-viewer']
  buttonsIds.forEach((buttonId, index) => {
    setupButton(buttonId, index)
  })

  setupInfoBoxEvents()
  showViewers(viewersVisibility)
  const events = ['mousemove', 'mousedown', 'touchmove']
  events.forEach(event => {
    document.addEventListener(event, () => {
      sendToParent(new Event('user-interacted'))
    })
  })
}

export default { createViewers }
